import { Directive, ElementRef, Input, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appAutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {

  private _autofocus;

  public constructor(
    private el: ElementRef,
  ) {
  }

  public ngAfterViewInit() {
    if (this._autofocus) {
      const el: HTMLInputElement = this.el.nativeElement;

      if (el.focus) {
        el.focus();
      } else {
        console.warn('AutofocusDirective: There is no .focus() method on the element:',
          this.el.nativeElement);
      }
    }
  }

  @Input()
  public set autofocus(value: any) {
    this._autofocus = value !== false
      && value !== null
      && value !== undefined
      && value !== 0
      && value !== 'false'
      && value !== 'null'
      && value !== 'undefined'
      && value !== '0'
      ;
  }
}
